import { ConectoresBloqueios } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/bloqueios',
    parent: '/conectores',
    text: 'Bloqueios',
    match: /\/conectores\/bloqueios+$/,
    sider: true,
    component: ConectoresBloqueios,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
